<div class="loan-card">
    <div class="loan-card__header">
        <img class="loan-card__logo no-dark-filter" [src]="offer.loanProviderImage" alt="Loan Provider">
        <button class="loan-card__select-button" (click)="onSelectClick()">
            Select
        </button>
    </div>

    <div class="loan-card__details">
        <!-- First Row -->
        <div class="loan-card__detail-row">
            <div class="loan-card__detail-column">
                <div class="loan-card__detail-label">Loan amount</div>
                <div class="loan-card__detail-value">{{ offer.loanAmount }}</div>
            </div>
            <div class="loan-card__divider-vertical"></div>
            <div class="loan-card__detail-column">
                <div class="loan-card__detail-label">APR</div>
                <div class="loan-card__detail-value">{{ offer.apr }}</div>
            </div>
        </div>

        <div class="loan-card__divider-horizontal"></div>

        <!-- Second Row -->
        <div class="loan-card__detail-row">
            <div class="loan-card__detail-column">
                <div class="loan-card__detail-label">Loan term</div>
                <div class="loan-card__detail-value">{{ offer.loanTerm }}</div>
            </div>
            <div class="loan-card__divider-vertical"></div>
            <div class="loan-card__detail-column">
                <div class="loan-card__detail-label">Monthly payment</div>
                <div class="loan-card__detail-value">{{ offer.monthlyPayment }}</div>
            </div>
        </div>
    </div>
</div>